import React, {useMemo} from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import styles from './chip.module.scss';
import {CHIP_CONFIG, ChipsProps} from '../types';
import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';

const ChipComponent: React.FC<ChipsProps> = ({type, variant = 'default'}) => {
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'md');
    const imageSquaredSize = isWideViewport ? 50 : 30;
    const chipConfig = useMemo(() => CHIP_CONFIG[type], [type]);
    const {color, title} = chipConfig;

    const containerClassName = useMemo(() => {
        return classNames({
            [styles['chips-container']]: variant === 'default',
            [styles['chips-container-inline']]: variant === 'inline',
        });
    }, [variant]);

    const containerStyle = useMemo(
        () => ({
            backgroundColor: color,
        }),
        [color],
    );

    return (
        <div
            className={containerClassName}
            style={containerStyle}
            role="img"
            aria-label={`${title} skill category`}
        >
            <Image
                src="/60-day-hustle/images/social-proof/60DH-PDE-Chips-Frame.svg"
                alt=""
                width={imageSquaredSize}
                height={imageSquaredSize}
                aria-hidden="true"
            />
            <span className={styles['chips-title']}>{title}</span>
        </div>
    );
};

export const Chip = React.memo(ChipComponent);
